import { isMobileOnly } from 'react-device-detect';

import { Background } from '../Background';
import { BackgroundVariant } from '../Background/Background';
import ActiveModal from '../modals/ActiveModal/ActiveModal';
import { Nav } from '../Nav';

import useAcceptOrgInvite from '~/hooks/useAcceptOrgInvite';
import useCheckClientVersionOutdated from '~/hooks/useCheckClientVersionOutdated';
import { Toast } from '~/hooks/useToast';

interface LayoutProps {
  children: React.ReactElement;
  backgroundVariant?: BackgroundVariant;
}

const Layout = ({ children, backgroundVariant = 'default' }: LayoutProps) => {
  // Hooks
  useCheckClientVersionOutdated();
  // Hook that monitors the URL for an org invite and accepts it
  useAcceptOrgInvite();

  return (
    <div
      className="flex h-[100dvh] w-screen overflow-hidden p-2"
      data-testid="layout-container"
    >
      <div
        className="border-primary-border flex flex-1 overflow-hidden rounded-lg border"
        data-testid="main-container"
      >
        <div className="flex flex-1 flex-col" data-testid="content-wrapper">
          {!isMobileOnly && (
            <div className="flex" data-testid="nav-wrapper">
              <Nav />
              <Toast />
            </div>
          )}
          <Background variant={backgroundVariant} />
          <div
            className="flex flex-1 flex-col overflow-y-auto"
            data-testid="active-modal-container"
          >
            {children}
            <ActiveModal />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
